import { Order } from '@/types';
import { bem } from '@/utilities';
import React, { useState } from 'react';

const blockClassName = bem('schedule-selection', 'order-list');

const ToggleView: React.FC<{ order: Order }> = ({ order }) => {
  const [showDetail, setShowDetail] = useState<boolean>(false);

  const handleClickLink = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    setShowDetail(!showDetail);
  };

  if (showDetail) {
    return (
      <>
        <p className={bem(blockClassName, 'item-operation-time')}>{`${order.duration}分`}</p>
        <p className={bem(blockClassName, 'item-location')}>{order.location}</p>
        <div className={bem(blockClassName, 'item-row')}>
          <p className={bem(blockClassName, 'item-name')}>{`${order.userName}様`}</p>
          <p className={bem(blockClassName, 'item-link')} onClick={(e) => handleClickLink(e)}>
            閉じる
          </p>
        </div>
      </>
    );
  } else {
    return (
      <div className={bem(blockClassName, 'item-row')}>
        <p className={bem(blockClassName, 'item-operation-time')}>{`${order.duration}分`}</p>
        <p className={bem(blockClassName, 'item-link')} onClick={(e) => handleClickLink(e)}>
          詳細を見る
        </p>
      </div>
    );
  }
};

type Props = {
  orders: Order[];
  selectedOrder?: Order;
  setSelectedOrder: (selectedOrder: Order) => void;
};

export const OrdersList: React.FC<Props> = (props) => {
  const { orders, selectedOrder, setSelectedOrder } = props;

  const handleClickItem = (order: Order) => {
    setSelectedOrder(order);
  };

  return (
    <div className={blockClassName}>
      {orders.map((order) => (
        <div className={bem(blockClassName, 'item')} onClick={() => handleClickItem(order)} key={order.id}>
          <div className={bem(blockClassName, 'item-row')}>
            <div className={bem(blockClassName, 'item-radio', { selected: order.id === selectedOrder?.id })}/>
            <p className={bem(blockClassName, 'item-number')}>{order.ownedCar.carNumber}</p>
          </div>
          {order.carManagementNumber && (
            <p className={bem(blockClassName, 'item-management-number')}>{order.carManagementNumber}</p>
          )}
          {order.ownedCar.vehicleNumber && (
            <p className={bem(blockClassName, 'item-vehicle-number')}>{order.ownedCar.vehicleNumber}</p>
          )}
          <p className={bem(blockClassName, 'item-model-name')}>{order.ownedCar.carModelName}</p>
          <p className={bem(blockClassName, 'item-model-number')}>{order.ownedCar.carModelNumber}</p>
          <ToggleView order={order}/>
        </div>
      ))}
    </div>
  );
};
